var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "91px",
    height: "91px",
    viewBox: "-0.5 -0.5 91 91",
    content: "<mxfile modified=\"2019-07-25T11:14:37.118Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/7.9.5 Chrome/58.0.3029.110 Electron/1.7.5 Safari/537.36\" etag=\"h1A1COSTrYpWu3LCzFw8\" version=\"11.0.5\" type=\"device\"><diagram id=\"b46GhhbTliVr-MqwqiZ4\" name=\"Page-1\">7Vddb5swFP01PGYCXELz2GVtJ23TKqXb+urBDVg1GBknwH79DLYBQz+SrtIqNTxE9vH1sbnnXJs4aJ3V1xwX6TcWA3V8N64d9MnxfS/05G8LNApYeEGokISTWAcNwIb8AQ26Gt2RGEorUDBGBSlsMGJ5DpGwMMw5q+ywLaP2qgVOYAZsIkzn6C8Si9Tszh3wz0CSVEwGfuPoPuFsl+vlHB9tu0cNZ9hQ6fgyxTGrRhC6dNCaMyZUK6vXQNvUmqypeVePjPbb5pCLQyZ8CS9uFz9ur8u7G1L/vAu/N1+XC1+x7DHdgXmNbrOiMfmBPL5o0yx7Ocsl+DEVGZU9TzZLwdl9nzcpqYHWjDLeEaCr7pEjihrimR7DK3h9YqTfgGUgeCNDqkGYQKczHWliMA4UC7K36bH2R9LT9SvcMCIX9l3t5ZWm0U5GoWszlGzHI9CTxpl+hgdNeATmCYgZj8wybkZhRRtQHr7dlffkrrx/C/eeDp9uxg6XDfV2pjdSd4A6wx5h3uAA81Iqz5HWtFVKBGwKHLUjlTzKbCPjslCHy5bUELc2NuXaejqhuCx1O2IZiXR7Syh9yOnP1cAeuID62CrQE/zATrXpj4rEC+dFYrCH6mGk0/EyLE8ytDIs3f8rQ/g+ZVi6b0uG89ONOoiD0ESc8w/By+7UKROaMT1yq77WZWPuw5OwXdWtJsKuXijr2UTWs1cSVXaHT2sVPvx9QZd/AQ==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 85 64 L 85 75 Q 85 85 75 85 L 15 85 Q 5 85 5 75 L 5 15 Q 5 5 15 5 L 75 5 Q 85 5 85 14.5 L 85 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 27.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#ffffff",
    stroke: "#ffffff",
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 62.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#ffffff",
    stroke: "#ffffff",
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.5,
    cy: 62.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#ffffff",
    stroke: "#ffffff",
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 62.5 L 28 32.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 63 L 29 28",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c072b114e3a6f1e8784903d9be6805d.svg";
export { ForwardRef as ReactComponent };